import { parseISO, format } from 'date-fns';

export class DateUtils {
    
    /**
     * Takes a date string and formats into the desired format. Returns a friendly message, 'Not Provided', if an error is encountered
     * @param {any} date An ISO 8601 string date
     * @param {any} desiredFormat Follows formatting as described here https://date-fns.org/v2.0.1/docs/parse
     */
    formatDateFriendly(date, desiredFormat) {

        // Default return value for invalid date value
        var result = 'Not Provided';

        if (date) {
            try {
                // Format the result using the provided format
                result = this.formatDate(date, desiredFormat);
            }
            catch (err) {
                console.error("formatDateFriendly(): Unable to parse date -> " + date);
            }
        }

        // Return the result
        return result;
    }

    /**
     * Takes a date string and returns a formatted date string. Caller provides own error handling
     * @param {any} date An ISO 8601 string date
     * @param {any} desiredFormat Follows formatting as described here https://date-fns.org/v2.0.1/docs/parse
     */
    formatDate(date, desiredFormat) {

        // Parse the given string in ISO 8601 format and return an instance of Date
        var dateObj = parseISO(date);

        // Format and return the result
        return format(dateObj, desiredFormat);
    }
}